import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';
import {IDeliveryPoint} from 'app/blocks/model/delivery-point.model';
import {IEmployee} from 'app/blocks/model/employee.model';
import {INote} from 'app/blocks/model/note.model';
import {MposDate} from 'app/blocks/util/mpos-date';
import {DiTime} from 'app/blocks/util/di-time';

export interface ITelesalesCall extends IBaseEntity {
    id?: number;
    referenceNo?: string;
    scheduledDate?: any;
    scheduledTime?: any;
    callStartTime?: any;
    callEndTime?: any;
    deliveryPoint?: IDeliveryPoint;
    telesalesRepresentative?: IEmployee;
    callStatus?: string;
    note?: INote;
    phoneNo?: string;
    sequence?: number | null;
}

export class TelesalesCall extends BaseEntity implements ITelesalesCall {
    public id?: number;
    public referenceNo?: string;
    public scheduledDate?: any;
    public scheduledTime?: any;
    public callStartTime?: any;
    public callEndTime?: any;
    public deliveryPoint?: IDeliveryPoint;
    public telesalesRepresentative?: IEmployee;
    public callStatus?: string;
    public note?: INote;
    public phoneNo?: string;
    public sequence?: number | null;

    constructor(telesalesCall?: any) {
        super();
        if (telesalesCall) {
            this.id = telesalesCall.id;
            this.referenceNo = telesalesCall.referenceNo;
            if (telesalesCall.scheduledDate) {
                this.scheduledDate = MposDate.newInstance(telesalesCall.scheduledDate);
            }
            if (telesalesCall.scheduledTime) {
                this.scheduledTime = DiTime.newInstance(telesalesCall.scheduledTime);
            }
            this.callStartTime = telesalesCall.callStartTime;
            this.callEndTime = telesalesCall.callEndTime;
            this.deliveryPoint = telesalesCall.deliveryPoint;
            this.telesalesRepresentative = telesalesCall.telesalesRepresentative;
            this.callStatus = telesalesCall.callStatus;
            this.note = telesalesCall.note;
            this.phoneNo = telesalesCall.phoneNo;
            this.sequence = telesalesCall.sequence !== undefined ? telesalesCall.sequence : null;
        }
    }

    clone(): IBaseEntity {
        return new TelesalesCall(this);
    }
}
